import { render, staticRenderFns } from "./CadUsuarios.vue?vue&type=template&id=7a3840f2&"
import script from "./CadUsuarios.ts?vue&type=script&lang=ts&"
export * from "./CadUsuarios.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports